import React from "react";
import { skills } from "../mock";

const categoryColors = {
  Product: { bg: "rgba(6,182,212,0.08)", border: "rgba(6,182,212,0.2)", text: "#06B6D4" },
  Analytics: { bg: "rgba(16,185,129,0.08)", border: "rgba(16,185,129,0.2)", text: "#10B981" },
  Strategy: { bg: "rgba(245,158,11,0.08)", border: "rgba(245,158,11,0.2)", text: "#F59E0B" },
  Technical: { bg: "rgba(139,92,246,0.08)", border: "rgba(139,92,246,0.2)", text: "#8B5CF6" },
  Leadership: { bg: "rgba(236,72,153,0.08)", border: "rgba(236,72,153,0.2)", text: "#EC4899" }
};

const SkillsSection = () => {
  return (
    <section id="skills" className="py-16 md:py-24" style={{ background: "#0C0C0E" }}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        {/* Section header */}
        <div className="mb-14">
          <p className="text-xs font-semibold uppercase tracking-widest text-[#06B6D4] mb-3">Expertise</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white">Skills & Tools</h2>
          <p className="text-[#71717A] mt-3 max-w-lg">
            A multi-disciplinary toolkit spanning product, data, and strategy.
          </p>
        </div>

        {/* Skills grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {skills.map((skillGroup, idx) => {
            const color = categoryColors[skillGroup.category] || categoryColors.Product;
            return (
              <div
                key={idx}
                className="p-6 rounded-xl border transition-all duration-300 hover:scale-[1.02]"
                style={{ background: "#0F0F11", border: "1px solid #1E1E24" }}
              >
                {/* Category label */}
                <div className="flex items-center gap-2 mb-5">
                  <span
                    className="w-2 h-2 rounded-full"
                    style={{ background: color.text }}
                  />
                  <span
                    className="text-xs font-bold uppercase tracking-widest"
                    style={{ color: color.text }}
                  >
                    {skillGroup.category}
                  </span>
                </div>

                {/* Skills */}
                <div className="flex flex-wrap gap-2">
                  {skillGroup.items.map((skill, i) => (
                    <span
                      key={i}
                      className="px-2.5 py-1 rounded-md text-xs font-medium transition-all duration-200 hover:scale-105 cursor-default"
                      style={{
                        background: color.bg,
                        border: `1px solid ${color.border}`,
                        color: color.text
                      }}
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
